export default __webpack_public_path__ + "static/media/anatomy-logo.0cbc8736.svg";